/*------------------------------------*/
/*------ ハンバーガーメニューの処理 ------*/
/*------------------------------------*/
$(".openbtn").on("click", function () {
    $(this).toggleClass('active');
    $(".sp-menu-drawer").toggleClass('active');
    $(".sp-nav-wrap").toggleClass('active');
    $(".header-wrap").toggleClass('active');
    $(".bg-black").toggleClass('active');
});

$(".bg-black").on("click", function () {
    $(this).toggleClass('active');
    $(".sp-menu-drawer").toggleClass('active');
    $(".sp-nav-wrap").toggleClass('active');
    $(".header-wrap").toggleClass('active');
    $(".openbtn").toggleClass('active');
});


/*-------------------------------------*/
/*------ ロード完了時のアニメーション ------*/
/*-------------------------------------*/

$(window).load(function(){
    $('#loading').addClass('loaded');
    $('footer').addClass('loaded');
});


/*------------------------------------*/
/*------ FVの文字ぼかしの時間差処理 ------*/
/*------------------------------------*/

$(window).load(function(){
    setTimeout(function () {
        $('.fv-wrapper h2').addClass('active');
        $('.check1').addClass('blur');
    }, 6500);
    setTimeout(function () {
        $('.check2').addClass('blur');
    }, 6700);
    setTimeout(function () {
        $('.check3').addClass('blur');
    }, 6900);
});


/*---------------------------------*/
/*------ TOP_ヘッダーに背景ひく ------*/
/*---------------------------------*/
$(window).scroll(function () {
    let scrollTop = $(window).scrollTop(); // スクロール上部の位置
    let targetTop = $("#shopify-section-template--16991481626906__9abd4ecd-fcf0-4f4e-80b6-84015cb0b76f").offset().top; // 対象エリアの上部の位置

    if (scrollTop > targetTop) {
        $('.header-wrap').addClass('add-bg');
    } else {
        $('.header-wrap').removeClass('add-bg');
    }
});